// extracted by mini-css-extract-plugin
module.exports = {"Button":"x_rX t_rX t_rK g_fk g_fy g_fn g_g9","full":"x_sH g_dk g_dv","width100":"x_dk g_dk","design3Pos":"x_sJ g_dP"};